// This file is auto-generated by Lovable. Do not modify it.

import { createLovableAuth } from "@lovable.dev/cloud-auth-js";
import { supabase } from "../supabase/client";

const DEFAULT_OAUTH_BROKER_URL = "https://95d53eab-a7b1-42cc-8031-c055e6ceb1ae.lovableproject.com/~oauth/initiate";
const oauthBrokerUrl = import.meta.env.VITE_LOVABLE_OAUTH_BROKER_URL || DEFAULT_OAUTH_BROKER_URL;

const lovableAuth = createLovableAuth({
  oauthBrokerUrl,
});

type SignInOptions = {
  redirect_uri?: string;
  extraParams?: Record<string, string>;
};

export const lovable = {
  auth: {
    signInWithOAuth: async (provider: "google" | "apple", opts?: SignInOptions) => {
      const result = await lovableAuth.signInWithOAuth(provider, {
        redirect_uri: opts?.redirect_uri,
        extraParams: {
          ...opts?.extraParams,
        },
      });

      if (result.redirected) {
        return result;
      }

      if (result.error) {
        return result;
      }

      try {
        await supabase.auth.setSession(result.tokens);
      } catch (e) {
        return { error: e instanceof Error ? e : new Error(String(e)) };
      }
      return result;
    },
  },
};
